import type EnType from '../en-US/project';

export default {
  'projectDetail.label.lookDetailButton': 'Ver Detalles',
} satisfies typeof EnType;
